import React from 'react'
import Field from '../../common/Field'
import Validator from '../../common/Validator'
import Reflux from 'reflux'
import Store from '../../../store/store'
import moment from 'moment'
import 'moment/locale/hu'
import 'react-datepicker/dist/react-datepicker.css'
import i18 from '../../../i18'
import api from '../../../source/api'
import DatePicker from 'react-date-picker';


class Upload extends Reflux.Component {

    constructor(props) {
        super(props);

        this.state = {
            config: props.config,
            processing: false,
            fields: {
                payment_method: {value: props.config.payment_method, error: '', role: {required: true}},
                date_type: {value: props.config.date_type, error: '', role: {required: true}},
                registration_number_transfer_huf: {value: props.config.registration_number_transfer_huf, error: '', role: {required: true}},
                registration_number_transfer_foreign: {value: props.config.registration_number_transfer_foreign, error: '', role: {required: true}},
                registration_number_cash_huf: {value: props.config.registration_number_cash_huf, error: '', role: {required: true}},
                registration_number_cash_foreign: {value: props.config.registration_number_cash_foreign, error: '', role: {required: true}},
                registration_number_card_huf: {value: props.config.registration_number_card_huf, error: '', role: {required: true}},
                registration_number_card_foreign: {value: props.config.registration_number_card_foreign, error: '', role: {required: true}},
                registration_number_voucher_huf: {value: props.config.registration_number_voucher_huf, error: '', role: {required: true}},
                registration_number_voucher_foreign: {value: props.config.registration_number_voucher_foreign, error: '', role: {required: true}},
                registration_number_other_huf: {value: props.config.registration_number_other_huf, error: '', role: {required: true}},
                registration_number_other_foreign: {value: props.config.registration_number_other_foreign, error: '', role: {required: true}},
                export_date_type: {value: props.config.export_date_type, error: '', role: {required: true}},
                job_number: {value: props.config.job_number, error: '', role: {required: false}},
                inputXml: {value: '', error: '', role: {required: true}},
                partners: {value: '', error: '', role: {required: false}},
            },
            start_date: new Date(props.config.start_date),
            end_date: new Date(props.config.end_date),
            date: {error: ''}
        };
        this.store = Store;
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
    };

    handleStartDateChange = (date) => {
        this.setState({
            start_date: date
        });
    };

    handleEndDateChange = (date) => {
        this.setState({
            end_date: date
        });
    };

    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value;
        fields[name].error = error;
        this.setState({fields: fields});
    };

    validate = (withApi) => {
        this.setState({processing: true});

        let fields = this.state.fields;
        fields.inputXml.role.required = !withApi;
        let validator = Validator.validate(fields)

        if (validator.error) {
            this.setState({
                processing: false,
                fields: validator.fields,
                error: validator.error
            });
            return false;
        }

        if (this.state.error || this.state.date.error) {
            this.setState({processing: false});
            return false;
        }

        return true;
    }

    buildSubmitForm = (withApi) => {
        let form = new FormData();
        form.append('payment_method', this.state.fields.payment_method.value);
        if (this.state.config.dateTypeVisible) {
            form.append('date_type', this.state.fields.date_type.value);
        }
        form.append('start_date', moment(this.state.start_date).format('YYYY-MM-DD'));
        form.append('end_date', moment(this.state.end_date).format('YYYY-MM-DD'));
        form.append('registration_number_transfer_huf', this.state.fields.registration_number_transfer_huf.value);
        form.append('registration_number_transfer_foreign', this.state.fields.registration_number_transfer_foreign.value);
        form.append('registration_number_cash_huf', this.state.fields.registration_number_cash_huf.value);
        form.append('registration_number_cash_foreign', this.state.fields.registration_number_cash_foreign.value);
        form.append('registration_number_card_huf', this.state.fields.registration_number_card_huf.value);
        form.append('registration_number_card_foreign', this.state.fields.registration_number_card_foreign.value);
        form.append('registration_number_voucher_huf', this.state.fields.registration_number_voucher_huf.value);
        form.append('registration_number_voucher_foreign', this.state.fields.registration_number_voucher_foreign.value);
        form.append('registration_number_other_huf', this.state.fields.registration_number_other_huf.value);
        form.append('registration_number_other_foreign', this.state.fields.registration_number_other_foreign.value);
        if (this.state.config.exportDateTypeVisible) {
            form.append('export_date_type', this.state.fields.export_date_type.value);
        }
        if (this.state.config.jobNumberVisible) {
            form.append('job_number', this.state.fields.job_number.value);
        }

        if (!withApi) {
            form.append('inputFile', document.querySelector('#inputXml').files[0])

            let partners = document.querySelector('#partners')
            form.append('partners', partners.files[0])
        }

        return form;
    };

    nextStep = (withApi) => {
        if (!this.validate(false)) {
            return;
        }
        let url = 'supplier/' + this.state.config.company_id + '/upload' + (withApi ? '-api' : '')
        let form = this.buildSubmitForm(withApi)

        api.postFile(url, form)
            .then((response) => {

                if (!withApi && response.data.outOfRange > 0) {
                    this.props.notifyError(response.data.outOfRange + ' számla kívül esik a dátum intervallumon!', 'error');
                }
                this.props.updateConfig(response.data.config);
                this.props.updateInvoices(response.data.invoices, this.props.supplierRules);
                this.props.updatePartners(response.data.partners);
                this.props.nextStep();
                this.setState({processing: false});
            })
            .catch((err) => {
                this.props.notifyError(err.response.data.message);
                this.setState({processing: false});
            });
    };

    export = (withApi) => {
        this.setState({processing: true});

        let form = new FormData();
        form.append('payment_method', this.state.fields.payment_method.value);
        form.append('date_type', this.state.fields.date_type.value);
        form.append('start_date', moment(this.state.start_date).format('YYYY-MM-DD'));
        form.append('end_date', moment(this.state.end_date).format('YYYY-MM-DD'));
        if (!withApi) {
            form.append('inputFile', document.querySelector('#inputXml').files[0])
        }

        api.postFile('supplier/' + this.state.config.company_id + '/export/generate', form)
            .then((response) => {
                api.downloadFile('supplier/' + this.state.config.company_id + '/download', response.data.name)

            })
            .catch((err) => {
                this.setState({processing: false});
                this.props.notifyError(err.response.data.error.message);
            });
    }

    onChangeSelect = (event) => {
        let fields = this.state.fields;
        fields[event.target.name].value = event.target.value;
        this.setState({fields: fields})
    }

    render() {
        return (
            <div className='supplier-upload-container'>
                <div className='row'>
                    <div className='col-3'>
                        <select value={this.state.fields.payment_method.value}
                                name='payment_method'
                                onChange={(event) => this.onChangeSelect(event)}
                                className='minimal-100  form-control'>
                            <option value='ALL'>Minden fizetési mód</option>
                            <option value='TRANSFER'>Utalás</option>
                            <option value='CASH'>Készpénz</option>
                            <option value='CARD'>Kártya</option>
                            <option value='VOUCHER'>Utalvány</option>
                            <option value='OTHER'>Egyéb</option>
                        </select>
                    </div>
                    <div className='col-3'>
                        {this.state.config.dateTypeVisible
                            ? <select value={this.state.fields.date_type.value}
                                      name='date_type'
                                      onChange={(event) => this.onChangeSelect(event)}
                                      className='minimal-100  form-control'>
                                <option value='issue'>Kiállítás alapján</option>
                                <option value='delivery'>Teljesítés alapján</option>
                            </select>
                            : null
                        }

                    </div>
                    <div className='col-3'>
                        <DatePicker
                            className="date-picker"
                            value={this.state.start_date}
                            onChange={this.handleStartDateChange}
                            required={true}
                            showLeadingZeros={true}
                        />
                    </div>
                    <div className='col-3'>
                        <DatePicker
                            className="date-picker"
                            value={this.state.end_date}
                            onChange={this.handleEndDateChange}
                            required={true}
                            showLeadingZeros={true}
                        />
                    </div>
                </div>

                {this.state.date.error
                    ? <p className='help-block help-block-error'>
                        <span className='error'><i className='fa fa-warning'/> {this.state.date.error}</span>
                    </p>
                    : null
                }
                <table className='table table-striped table-aibook-bordered'>
                    <thead>
                    <tr>
                        <th style={{width: '50%'}}>Fizetés típusa</th>
                        <th style={{width: '25%'}}>Forintos</th>
                        <th style={{width: '25%'}}>Devizás</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>KÉSZPÉNZES SZÁMLÁK RÖGZÍTÉSE</td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_cash_huf'
                                name='registration_number_cash_huf'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_cash_foreign'
                                name='registration_number_cash_foreign'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>ÁTUTALÁSOS SZÁMLÁK RÖGZÍTÉSE</td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_transfer_huf'
                                name='registration_number_transfer_huf'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_transfer_foreign'
                                name='registration_number_transfer_foreign'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>BANKKÁRTYÁS SZÁMLÁK RÖGZÍTÉSE</td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_card_huf'
                                name='registration_number_card_huf'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_card_foreign'
                                name='registration_number_card_foreign'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>UTALVÁNYOS SZÁMLÁK RÖGZÍTÉSE</td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_voucher_huf'
                                name='registration_number_voucher_huf'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_voucher_foreign'
                                name='registration_number_voucher_foreign'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>EGYÉB SZÁMLÁK RÖGZÍTÉSE</td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_other_huf'
                                name='registration_number_other_huf'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_other_foreign'
                                name='registration_number_other_foreign'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    {this.state.config.exportDateTypeVisible
                        ? <tr>
                            <td>Exportban szereplő dátum érték</td>
                            <td colSpan='2' className='text-center'>
                                <select value={this.state.fields.export_date_type.value}
                                        name='export_date_type'
                                        onChange={(event) => this.onChangeSelect(event)}
                                        className='minimal-100  form-control'>
                                    <option value='DELIVERY_DATE'>Teljesítés dátuma</option>
                                    <option value='ISSUE_DATE'>Kelte dátuma</option>
                                </select>
                            </td>
                        </tr>
                        : null
                    }
                    {this.state.config.jobNumberVisible
                        ? <tr>
                            <td>Munkaszám</td>
                            <td colSpan="2" className="text-right">
                                <Field
                                    type='text'
                                    id='job_number'
                                    name='job_number'
                                    label=''
                                    classLabel='control-label'
                                    classInput='bordered-input'
                                    setValue={this.setValue.bind(this)}
                                    state={this.state}
                                    style={{width: '100%'}}
                                />
                            </td>
                        </tr>
                        : null
                    }
                    </tbody>
                </table>
                <div className='row'>
                    <div className='col-12'>

                        {this.state.config.fileInputVisible
                            ? <React.Fragment>
                                <div className='row mb-2'>
                                    <label htmlFor='inputXml' className='col-md-3 text-right'>Travel XML file</label>
                                    <Field
                                        type='file'
                                        id='inputXml'
                                        name='inputXml'
                                        fileUploadEndpoint=''
                                        classInput='file-input'
                                        setValue={this.setValue.bind(this)}
                                        state={this.state}
                                        style={{width: '350px', margin: 'auto'}}
                                    />
                                </div>
                                <div className='row'>
                                    <label htmlFor='partners' className='col-md-3 text-right'>Partnerek excel</label>
                                    <Field
                                        type='file'
                                        id='partners'
                                        name='partners'
                                        fileUploadEndpoint=''
                                        classInput='file-input'
                                        setValue={this.setValue.bind(this)}
                                        state={this.state}
                                        style={{width: '350px', margin: 'auto'}}
                                    />
                                </div>
                            </React.Fragment>
                            : null
                        }
                    </div>
                    <div className='next-step-btn-container text-center mt-4' style={{width: '100%'}}>
                        <a onClick={() => this.export(this.state.config.onlineSzamlaVisible)} className='next-step mr-2'>Számlák excel exportálása</a>
                        <a onClick={() => this.nextStep(this.state.config.onlineSzamlaVisible)} className={this.state.processing ? 'disabled next-step' : 'next-step'}>{this.state.processing ? i18.BUTTONS._processing : i18.BUTTONS._goToAccountAssignment}</a>
                    </div>
                </div>
            </div>
        )
    }
}

export default Upload


// WEBPACK FOOTER //
// ./src/components/supplier/steps/upload.js